import type { StoryObj } from '@storybook/html'
import type { CobaltToggle as CobaltToggleProps } from './cobalt-toggle'

export default {
  title: 'Components/Form/cobalt-toggle',
  argTypes: {
    label: {
      type: { name: 'string', required: true },
      description: 'This is the text which accompany the toggle. It is **required** for accessibility concerns.'
    },
    format: {
      control: 'select',
      options: ['right', 'left', 'hidden'],
      description: 'A string indicating the position of the label or if it is hidden.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'right' }
      }
    },
    selected: {
      control: 'boolean',
      options: [true, false],
      description: 'A Boolean indicating whether the toggle is selected or unselected.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false }
      }
    },
    disabled: {
      control: 'boolean',
      options: [true, false],
      description: 'A boolean indicating the disable state of the toggle. The `aria-disabled` attribute relies on this property.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false }
      }
    },
    cobaltToggleChange: {
      description: 'Custom event emitted when toggle is selected or not',
      table: {
        type: {
          summary: 'Integration',
          detail:
            'React: onCobaltToggleChange={handleChange}\nVue:@cobaltToggleChange="handleChange"\nAngular:(cobaltToggleChange)="handleChange()"\nVanillaJs:.addEventListener("cobaltToggleChange", (event) => {//handle change});'
        }
      },

      action: 'cobaltToggleChange'
    }
  }
}

const TemplateDefault = (args: CobaltToggleProps) => {
  return `
<cobalt-toggle label="${args.label}" selected="${args.selected}" disabled="${args.disabled}" format="${args.format}"></cobalt-toggle>
  `
}

export const Default: StoryObj = TemplateDefault.bind({})

Default.args = {
  label: 'Label',
  selected: false,
  format: 'right',
  disabled: false
}

const TemplateDescription = (args: CobaltToggleProps) => {
  return `
<cobalt-toggle label="${args.label}" description="${args.description}"></cobalt-toggle>
  `
}

export const WithDescription: StoryObj = TemplateDescription.bind({})

WithDescription.args = {
  label: 'Label',
  description: 'A description'
}

const TemplateOnChangeEvent = (args: CobaltToggleProps) => {
  return `
<script>
  document.querySelector('#toggle-on-change').addEventListener('cobaltToggleChange', (e) => {
    document.querySelector('#toggle-selected').textContent = e.detail
  })
</script>
<div style="display:flex; flex-direction: column; gap: var(--number-spacing-large);">
  <p class="typography-body-medium-regular">Toggle is selected: <span id="toggle-selected">false</span></p>
  <cobalt-toggle id="toggle-on-change" label="${args.label}"></cobalt-toggle>
</div>
`
}

export const OnChangeEvent: StoryObj = TemplateOnChangeEvent.bind({})

OnChangeEvent.args = {
  label: 'Label'
}
